import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ChatEventsService  } from '@shared/services';
import { Room               } from '@shared/factories';

const STACK_SIZE = 3;

@Component({
  selector:      'chat-recent',
  templateUrl: './chat-recent.component.html',
  host: { class: 'am-flex-align gap-xxs' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatRecentComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  rooms: Room[] = [];
  constructor( private chatEventsService: ChatEventsService ) { }

  ngOnInit(): void {
    this.chatEventsService.rooms.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(rooms => this.rooms = rooms ? [...rooms] : []);
  }

  get stackRooms(): Room[] {
    return this.rooms.filter(r => r?.active).sort((a, b) => (a.openedAt?.getTime() || 0) - (b.openedAt?.getTime() || 0)).slice(-STACK_SIZE);
  }

}
